import type { ChangeEvent, Dispatch, SetStateAction } from 'react'
import { Block, Select, Switch, Text } from '@mote/ui/components'
import styled, { css, th } from '@xstyled/styled-components'

export type USStateValue = {
  text: string
  value: string
}

export type USStates = Array<USStateValue>

const US_STATES: USStates = [
  {
    text: 'AL',
    value: 'AL'
  },
  {
    text: 'AK',
    value: 'AK'
  },
  {
    text: 'AS',
    value: 'AS'
  },
  {
    text: 'AZ',
    value: 'AZ'
  },
  {
    text: 'AR',
    value: 'AR'
  },
  {
    text: 'CA',
    value: 'CA'
  },
  {
    text: 'CO',
    value: 'CO'
  },
  {
    text: 'CT',
    value: 'CT'
  },
  {
    text: 'DE',
    value: 'DE'
  },
  {
    text: 'DC',
    value: 'DC'
  },
  {
    text: 'FM',
    value: 'FM'
  },
  {
    text: 'FL',
    value: 'FL'
  },
  {
    text: 'GA',
    value: 'GA'
  },
  {
    text: 'GU',
    value: 'GU'
  },
  {
    text: 'HI',
    value: 'HI'
  },
  {
    text: 'ID',
    value: 'ID'
  },
  {
    text: 'IL',
    value: 'IL'
  },
  {
    text: 'IN',
    value: 'IN'
  },
  {
    text: 'IA',
    value: 'IA'
  },
  {
    text: 'KS',
    value: 'KS'
  },
  {
    text: 'KY',
    value: 'KY'
  },
  {
    text: 'LA',
    value: 'LA'
  },
  {
    text: 'ME',
    value: 'ME'
  },
  {
    text: 'MH',
    value: 'MH'
  },
  {
    text: 'MD',
    value: 'MD'
  },
  {
    text: 'MA',
    value: 'MA'
  },
  {
    text: 'MI',
    value: 'MI'
  },
  {
    text: 'MN',
    value: 'MN'
  },
  {
    text: 'MS',
    value: 'MS'
  },
  {
    text: 'MO',
    value: 'MO'
  },
  {
    text: 'MT',
    value: 'MT'
  },
  {
    text: 'NE',
    value: 'NE'
  },
  {
    text: 'NV',
    value: 'NV'
  },
  {
    text: 'NH',
    value: 'NH'
  },
  {
    text: 'NJ',
    value: 'NJ'
  },
  {
    text: 'NM',
    value: 'NM'
  },
  {
    text: 'NY',
    value: 'NY'
  },
  {
    text: 'NC',
    value: 'NC'
  },
  {
    text: 'ND',
    value: 'ND'
  },
  {
    text: 'MP',
    value: 'MP'
  },
  {
    text: 'OH',
    value: 'OH'
  },
  {
    text: 'OK',
    value: 'OK'
  },
  {
    text: 'OR',
    value: 'OR'
  },
  {
    text: 'PW',
    value: 'PW'
  },
  {
    text: 'PA',
    value: 'PA'
  },
  {
    text: 'PR',
    value: 'PR'
  },
  {
    text: 'RI',
    value: 'RI'
  },
  {
    text: 'SC',
    value: 'SC'
  },
  {
    text: 'SD',
    value: 'SD'
  },
  {
    text: 'TN',
    value: 'TN'
  },
  {
    text: 'TX',
    value: 'TX'
  },
  {
    text: 'UT',
    value: 'UT'
  },
  {
    text: 'VT',
    value: 'VT'
  },
  {
    text: 'VI',
    value: 'VI'
  },
  {
    text: 'VA',
    value: 'VA'
  },
  {
    text: 'WA',
    value: 'WA'
  },
  {
    text: 'WV',
    value: 'WV'
  },
  {
    text: 'WI',
    value: 'WI'
  },
  {
    text: 'WY',
    value: 'WY'
  }
]

export type DebugUSSate = {
  stateOverride: string
  networkBusy: boolean
  disableGeoIp: boolean
  networkError: string | boolean
}

type UpdateStateMethod = 'setDisableGeoIp' | 'setStateOverride'

type INetworkStatus = 'idle' | 'error' | 'busy'

export type DebugUSUpdateState = {
  setDisableGeoIp: Dispatch<SetStateAction<boolean>>
  setStateOverride: Dispatch<SetStateAction<string>>
}

export interface DebugUSSchoolOptionsProps {
  debugState: DebugUSSate
  updateState: DebugUSUpdateState
}

export const DebugUSSchoolOptions = (props: DebugUSSchoolOptionsProps) => {
  const networkStatus: INetworkStatus = props.debugState.networkError
    ? 'error'
    : props.debugState.networkBusy
    ? 'busy'
    : 'idle'

  function handleChange(method: UpdateStateMethod, value: any) {
    props.updateState[method](value)
  }

  return (
    <Block
      layout='vertical'
      align='flex-start'
      justify='flex-start'
      gap={12}
      spreadX
    >
      <Block layout='horizontal' align='center' gap={8}>
        <Text text='sm' fontWeight='normal'>
          Disable GeoIP:
        </Text>
        <Switch
          //@ts-expect-error
          checked={props.debugState.disableGeoIp}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            handleChange('setDisableGeoIp', event.target.checked)
          }
        />
      </Block>
      <Block layout='horizontal' align='center' gap={6}>
        <Text text='sm' fontWeight='normal'>
          State:
        </Text>
        <Select
          h='28px'
          currentValue={props.debugState.stateOverride}
          options={US_STATES}
          placeholder='Select...'
          onChange={(event: ChangeEvent<HTMLSelectElement>) =>
            handleChange('setStateOverride', event.target.value)
          }
        />
      </Block>
      <Text text='sm' fontWeight='normal'>
        Network status:{' '}
        <NetworkStatus status={networkStatus}>
          {props.debugState.networkError ?? props.debugState.networkBusy
            ? 'Busy'
            : 'Idle'}
        </NetworkStatus>
      </Text>
    </Block>
  )
}

const NetworkStatus = styled.span<{
  status: INetworkStatus
}>`
  ${({ status }) => {
    switch (status) {
      case 'error':
        return css`
          color: ${th.color('error')};
        `
      case 'busy':
        return css`
          color: ${th.color('warning')};
        `
      case 'idle':
        return css`
          color: ${th.color('success')};
        `
      default:
        return css`
          color: ${th.color('black')};
        `
    }
  }};
`
